export default __webpack_public_path__ + "static/media/img (2).01b928e7.jpg";